/**
 * The way in to Prest0 Inc.'s engineering page, /activity/engineering (Miles, 2026-10-23): the account menu offers it,
 * and /activity links to it, only in Prest0 Inc.'s workspace and only to someone holding `developer.escalations.view` —
 * the widest of the page's keys (the Claude Code queue's: owners, admins, members and assistants of Prest0 Inc. hold it).
 *
 * Both halves are needed, as for the studios (useRoadmapStudioAccess.ts): `hasPermission` answers true for the owner of
 * ANY workspace, while the developer keys mean something only in a developer organization. The workspace is the ACTIVE
 * one, never the home org.
 *
 * This hides chrome only. The route's DeveloperRoute and every view's callable decide.
 */
import { PREST0_INC_ACCOUNT_ID } from '../config/internalAccess';

/** The key the page's route asks for (src/App.tsx), and so the key its way in asks for. */
export const ENGINEERING_PAGE_KEY = 'developer.escalations.view';

/** The permission answer the rule needs (useUsageVisibility's `loading` and `hasPermission`). */
export interface EngineeringPermissions {
  loading?: boolean;
  hasPermission?: (key: string) => boolean;
}

/** May the way in show, in this workspace, for this permission answer? False while it loads (fail closed). Pure. */
export function canSeeEngineering(activeAccountId: string | null, perms: EngineeringPermissions): boolean {
  if (perms.loading || typeof perms.hasPermission !== 'function') return false;
  return activeAccountId === PREST0_INC_ACCOUNT_ID && perms.hasPermission(ENGINEERING_PAGE_KEY);
}

